import React from 'react';

const formatCount = (value) => Number(value || 0).toLocaleString('uk-UA');

const formatShare = (count, total) => {
  if (!total || !count) return '0';
  const value = (count / total) * 100;
  if (value >= 10) return value.toFixed(0);
  if (value >= 1) return value.toFixed(1);
  if (value >= 0.01) return value.toFixed(2);
  return '<0.01';
};

const detailsText = (reason) =>
  (reason.details || []).map((item) => `${item.value} (${formatCount(item.count)})`).join(' · ');

export default function BlockReasons({ stats, loading, activeMatch, onSelect }) {
  if (loading && !stats) {
    return (
      <div className="app-editor-card compact-card mt-3">
        <div className="app-editor-card-body compact-card-body">
          <div className="reasons-head">
            <div className="stats-section-title">Причини відсіву</div>
          </div>
          <div className="reasons-bar is-loading" />
        </div>
      </div>
    );
  }

  if (!stats || !stats.reasons?.length) return null;

  const total = stats.total || 0;
  const passed = Math.max(total - (stats.blocked || 0), 0);
  const sorted = [...stats.reasons].sort((a, b) => b.count - a.count);
  const active = sorted.find((reason) => reason.match && reason.match === activeMatch);

  const segments = [
    { key: '__passed', label: 'Пройшли', count: passed, tone: 'pass' },
    ...sorted
      .filter((reason) => reason.blocked)
      .map((reason) => ({ key: reason.label, label: reason.label, count: reason.count, tone: 'block' })),
  ].filter((segment) => segment.count > 0);

  const renderChip = (reason) => {
    const clickable = Boolean(reason.match);
    const isActive = Boolean(activeMatch) && activeMatch === reason.match;
    const details = detailsText(reason);

    return (
      <button
        key={reason.label}
        type="button"
        className={`reason-chip${isActive ? ' is-active' : ''}${details ? ' has-details' : ''}`}
        onClick={() => clickable && onSelect(isActive ? '' : reason.match)}
        disabled={!clickable}
        title={details || reason.label}
      >
        <span className={`reason-dot is-${reason.blocked ? 'block' : 'pass'}`} />
        <span className="reason-chip-name">{reason.label}</span>
        <span className="reason-chip-count">{formatCount(reason.count)}</span>
        <span className="reason-chip-share">{formatShare(reason.count, total)}%</span>
      </button>
    );
  };

  return (
    <div className="app-editor-card compact-card mt-3">
      <div className="app-editor-card-body compact-card-body">
        <div className="reasons-head">
          <div className="reasons-title">
            <span className="stats-section-title">Причини відсіву</span>
            <span className="reasons-summary">
              заблоковано {formatCount(stats.blocked)} з {formatCount(total)} ·{' '}
              {formatShare(stats.blocked, total)}%
            </span>
          </div>

          {activeMatch ? (
            <button type="button" className="reasons-reset" onClick={() => onSelect('')}>
              Скинути фільтр
            </button>
          ) : null}
        </div>

        <div className="reasons-bar">
          {segments.map((segment) => (
            <span
              key={segment.key}
              className={`reasons-bar-seg is-${segment.tone}`}
              style={{ width: `${(segment.count / total) * 100}%` }}
              title={`${segment.label}: ${formatCount(segment.count)}`}
            />
          ))}
        </div>

        <div className="reasons-chips">{sorted.map(renderChip)}</div>

        {active?.details?.length ? (
          <div className="reasons-detail">
            <span className="reasons-detail-title">{active.label}</span>
            {active.details.map((item) => (
              <span className="reasons-detail-item" key={item.value}>
                {item.value}
                <b>{formatCount(item.count)}</b>
              </span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
